// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1frD9","content":"styles_content__2nrE8"};